/**
 * Store CardBiz ECR void metadata in payment.checkoutID (prefix avoids online-payment clash).
 */
const PREFIX = 'cardbiz-ecr:';

export type EcrPaymentMeta = {
	invoiceNumber?: string | null;
	approvalCode?: string | null;
};

export function encodeEcrPaymentMeta(meta: EcrPaymentMeta): string | undefined {
	if (!meta.invoiceNumber && !meta.approvalCode) {
		return undefined;
	}
	return (
		PREFIX +
		JSON.stringify({
			inv: meta.invoiceNumber || '',
			appr: meta.approvalCode || '',
		})
	);
}

export function decodeEcrPaymentMeta(
	checkoutID?: string | null,
): EcrPaymentMeta | null {
	if (!checkoutID || !String(checkoutID).startsWith(PREFIX)) {
		return null;
	}
	try {
		const parsed = JSON.parse(String(checkoutID).slice(PREFIX.length));
		return {
			invoiceNumber: parsed.inv || null,
			approvalCode: parsed.appr || null,
		};
	} catch {
		return null;
	}
}

export function isEcrPaymentRecord(checkoutID?: string | null): boolean {
	return Boolean(checkoutID && String(checkoutID).startsWith(PREFIX));
}
